import { render, staticRenderFns } from "./WechatPayOrder.vue?vue&type=template&id=0f303021&scoped=true"
import script from "./WechatPayOrder.vue?vue&type=script&lang=js"
export * from "./WechatPayOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f303021",
  null
  
)

export default component.exports